"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelForWidget = exports.getChannelsGroupedByIds = exports.getAllChannelsGroupedByIds = exports.getChannelsInternal = exports.getChannels = exports.isFetchingChannels = exports.getChannelById = exports.getChannelIds = exports.filterInternalChannels = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var channel_types_1 = require("@wix/wix-vod-constants/dist/common/channel-types");
var reselect_1 = require("reselect");
var isInternalChannel = function (channel) {
    return channel.channelType === channel_types_1.CHANNEL_TYPES.CHANNEL;
};
var filterInternalChannels = function (channels) {
    return (0, lodash_1.filter)(channels, isInternalChannel);
};
exports.filterInternalChannels = filterInternalChannels;
function getChannelIds(state) {
    return state.channels.ids;
}
exports.getChannelIds = getChannelIds;
function getChannelById(state, channelId) {
    return state.entities.channels[channelId];
}
exports.getChannelById = getChannelById;
function isFetchingChannels(state) {
    return state.channels.activeRequests !== 0;
}
exports.isFetchingChannels = isFetchingChannels;
/**
 * @param state
 * @returns {Object[]} channels list
 */
exports.getChannels = (0, reselect_1.createSelector)([function (state) { return state; }, getChannelIds], function (state, ids) { return (0, lodash_1.map)(ids, (0, lodash_1.partial)(getChannelById, state)); });
exports.getChannelsInternal = (0, reselect_1.createSelector)(exports.getChannels, exports.filterInternalChannels);
var getAllChannelsGroupedByIds = function (state) { return state.entities.channels; };
exports.getAllChannelsGroupedByIds = getAllChannelsGroupedByIds;
/**
 * @param state
 * @returns {Object} {id: channel}
 */
exports.getChannelsGroupedByIds = (0, reselect_1.createSelector)([exports.getAllChannelsGroupedByIds, getChannelIds], lodash_1.pick);
/**
 * @param state
 * @returns {Object} channel
 */
exports.getChannelForWidget = (0, reselect_1.createSelector)([
    function (_a) {
        var channelInfo = _a.channelInfo;
        return (0, lodash_1.get)(channelInfo, 'info');
    },
    function (_a) {
        var channelInfo = _a.channelInfo;
        return (0, lodash_1.get)(channelInfo, 'paymentInfo');
    },
], function (info, paymentInfo) {
    if (!info && !paymentInfo) {
        return null;
    }
    return tslib_1.__assign(tslib_1.__assign({}, info), paymentInfo);
});
//# sourceMappingURL=channels.js.map